import React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
const SVG = ({
  className = '',
  size = '24'
}) => ___EmotionJSX("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: size,
  height: size,
  className: className,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, ___EmotionJSX("polyline", {
  points: "17 1 21 5 17 9"
}), ___EmotionJSX("path", {
  d: "M3 11V9a4 4 0 0 1 4-4h14"
}), ___EmotionJSX("polyline", {
  points: "7 23 3 19 7 15"
}), ___EmotionJSX("path", {
  d: "M21 13v2a4 4 0 0 1-4 4H3"
}));
export default SVG;